import { Box, Stack, Typography } from "@mui/material";
import { loginWithRedirect } from "@newsenec/auth-provider";
import { SenecButton } from "@newsenec/ui-components";
import { useTranslation } from "react-i18next";

const WelcomeBanner = () => {
    const { t } = useTranslation();

    return (
        <Stack direction="row" alignItems="center" justifyContent="center">
            <Box sx={{ display: { xs: "none", md: "flex" } }}>
                <img src="/fpp-logo.png" alt="Fachpartner-Portal Icon" height="100px" />
            </Box>
            <Box sx={{ textAlign: { xs: "center", md: "inherit" } }}>
                <Typography variant="h1" color="text.light">
                    {t("welcomeScreenCockpitWelcomeText")} Italy
                </Typography>
                <Typography color="text.light">{t("welcomeScreenCockpitWelcomeSubtitle")}</Typography>
            </Box>
        </Stack>
    );
};

export const ActionButtons = () => {
    const { t } = useTranslation();
    return (
        <Stack direction="row" spacing={2}>
            <SenecButton
                sx={{
                    backgroundColor: "impulseOrange.main",
                    "&:hover, &:active": {
                        backgroundColor: "#D8790C",
                    },
                }}
                data-testid="login-welcome-login-btn"
                onClick={() => loginWithRedirect()}
            >
                {t("welcomeScreenLoginLabel")}
            </SenecButton>
        </Stack>
    );
};

export const WelcomeScreenCockpitIT = () => {
    return (
        <Stack
            width="100vw"
            minHeight="100vh"
            alignItems="center"
            justifyContent="center"
            spacing={5}
            sx={{
                backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(/accumulo-wallbox-pro.webp)",
                backgroundSize: "cover",
                backgroundAttachment: "fixed",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                padding: "1rem",
            }}
        >
            <img src="/senec-logo-white.png" alt="SENEC Logo" height="30px" />
            <WelcomeBanner />
            <ActionButtons />
        </Stack>
    );
};
